import Fetching from "@/components/Fetching/Fetching";
import { CheckCircle2, CircleX } from "lucide-react";

import classes from "./integration.module.scss";

const IntegrationDelivery = ({ completeOrder, completeOrderDelivery, messageOrderDelivery }) => {
	return (
		<div className={`${classes.content} ${completeOrder && !completeOrderDelivery && classes.inProcess} ${completeOrderDelivery && classes.complete}`}>
			<div>
				Obteniendo Guías de Despacho <br />
				{messageOrderDelivery && <small>{messageOrderDelivery}</small>}
			</div>
			<div>
				{completeOrder && !completeOrderDelivery && <Fetching topMargin={"0px"} />}{" "}
				{completeOrderDelivery && messageOrderDelivery === "" && <CheckCircle2 className={`${classes.checkIcon} ${classes.successIcon}`} />}
				{completeOrderDelivery && messageOrderDelivery !== "" && <CircleX className={`${classes.checkIcon} ${classes.errorIcon}`} />}
			</div>
		</div>
	);
};

export default IntegrationDelivery;
